// The card gate's decisions (CardGate.js renders them). Kept pure so the
// rules are tested on their own:
//
//   flag off (REQUIRE_VALID_CARD) / Shopify-embedded / no brand → open
//   cardStatus 'valid'                                          → open
//   platform admin (adminRole ADMIN+)                           → open + banner
//   anyone else                                                 → the gate
//     (the owner / manageBilling / admin get the card form; other members
//      get the notice to ask the owner)
//
// The status comes from GET /brands/:id/billing (`cardStatus`) for those who
// may open the billing, and from GET /brands/:id/billing/status for the rest.
// An API without `cardStatus` yet: derived from the saved payment method.

export const CARD_STATUSES = ['valid', 'missing', 'expired', 'failed'];

export function deriveCardStatus(billing, today = new Date()) {
  if (billing && CARD_STATUSES.includes(billing.cardStatus)) return billing.cardStatus;
  const pm = billing?.paymentMethod;
  if (!pm) return 'missing';
  if (pm.expMonth && pm.expYear && new Date(Number(pm.expYear), Number(pm.expMonth), 1) <= today) return 'expired';
  return 'valid';
}

export function gateDecision({ enabled, embedded, hasBrand, status, isAdmin }) {
  if (!enabled || embedded || !hasBrand) return 'open';
  if (status === 'valid') return 'open';
  if (status == null) return 'open'; // unknown (no status readable for this user)
  if (isAdmin) return 'bypass';
  return 'gate';
}

const EVENT = 'outfino:billing-changed';

/// The Számlázás page tells the gate that the card changed.
export function announceBillingChange(brandId) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT, { detail: { brandId } }));
}

export function onBillingChange(handler) {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
